var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelayOff1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0846 20.1373L18.7732 9.49142C18.8394 9.3997 18.9831 9.47124 18.9499 9.57938L16.7864 16.6106C16.6677 16.9965 16.9562 17.3871 17.3599 17.3871H20.4769C20.7216 17.3871 20.8634 17.6643 20.7201 17.8627L12.9663 28.5987C12.9024 28.6872 12.7633 28.624 12.7878 28.5177L14.4424 21.3478C14.5292 20.9718 14.2436 20.6129 13.8578 20.6129H11.3278C11.083 20.6129 10.9413 20.3357 11.0846 20.1373Z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 5C18.0001 3.895 17.1051 3 16.0001 3C14.8951 3 14.0001 3.895 14.0001 5C14.0001 6.105 14.8951 7 16.0001 7C17.1051 7 18.0001 6.105 18.0001 5Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelayOff1);
export default __webpack_public_path__ + "static/media/relay-off-1.b4202e71e004f21e6be4f697eadbef98.svg";
export { ForwardRef as ReactComponent };